import baseHttpService from "core/http/singleton/base";
import {
  checkIsExitsReqArriveLateUrl,
  createReqArriveLateUrl,
  createReqLeaveUrl,
  deleteRequestUrl,
  getDirectionManagerUrl,
  getListArriveLateUrl,
  getListEmployeeUrl,
  getPaidLeaveBalanceUrl,
  getTimeKeepingSummaryUrl,
  handleRequestUrl,
  getListRequestLeaveConfigUrl,
  listReasonArriveLateUrl,
  listReasonLeaveUrl,
  postFileUrl,
  getLeaveManagerReqUrl,
  checkIsExitsReqLeaveUrl,
  getListManagerOfDepartmentUrl,
  sendFeedbackUrl,
  getConfigMinDateUrl,
  getListTimeKeepingHRUrl,
  getCategoryOptionUrl,
  exportTimeKeepingHRUrl,
  confirmTimeKeepingMonthUrl,
  exportTimeKeepingMonthUrl,
  getListTimeKeepingManagerUrl,
  confirmTimeKeepingUrl,
  exportTimeKeepingManagerUrl,
  getTimeKeepingManagerDetailUrl,
  getRangeTimeKeepingUrl,
  getEmployeeOfManagerUrl,
  getHrReportUrl,
  exportHrReportUrl,
  getTimeConfirmPeriodUrl,
  checkInOnlineApiUrl,
  cancelRequestUrl,
  exportTemplateTimeKeepingUrl,
  importTimeKeepingUrl,
  getManagerApproveEarlyRegisterUrl,
  createEarlyRegistrationUrl,
  getEarlyRegistrationDetailUrl,
} from "./urls";
import { TYPE_LEAVE } from "modules/DeclareLeave/redux/getReasonLeave";
import { IHandleRequestParams } from "./resTypes";
import { postFileRes } from "./type";
import { SCREEN } from "helper/roleChecker/Screens";

export const getListReasonArriveLateApi = async () => {
  const res = await baseHttpService.get(listReasonArriveLateUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListReasonLeaveApi = async (type: TYPE_LEAVE) => {
  const res = await baseHttpService.get(listReasonLeaveUrl(type));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const createReqArriveLateApi = async (formData, screenCode) => {
  const res = await baseHttpService.post(
    createReqArriveLateUrl(screenCode),
    formData
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getDirectionManagerApi = async () => {
  const res = await baseHttpService.get(getDirectionManagerUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListArriveLateConfigApi = async (screenCode, params) => {
  const res = await baseHttpService.get(
    getListArriveLateUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListEmployeeApi = async (params) => {
  const res = await baseHttpService.get(getListEmployeeUrl, params);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const deleteRequestApi = async (screenCode, id, tab) => {
  const res = await baseHttpService.delete(
    deleteRequestUrl(screenCode, id, tab)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getPaidLeaveBalanceApi = async (screenCode) => {
  const res = await baseHttpService.get(getPaidLeaveBalanceUrl(screenCode));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
export const getListRequestLeaveConfigApi = async (
  screenCode: SCREEN,
  params: {
    month: number;
    year: number;
    isAdmin?: boolean;
    employeeCode: string;
  }
) => {
  const res = await baseHttpService.get(
    getListRequestLeaveConfigUrl(screenCode, params.isAdmin),
    {
      month: params.month,
      year: params.year,
      employeeCode: params?.employeeCode,
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getTimeKeepingSummaryApi = async ({ year, month, screenCode }) => {
  const res = await baseHttpService.get(getTimeKeepingSummaryUrl(screenCode), {
    year,
    month,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const handleRequestApi = async (
  tab: "lack-of-time" | "list-feedback" | "late" | "register-early",
  payload: IHandleRequestParams,
  screenCode: SCREEN
) => {
  const res = await baseHttpService.put(
    handleRequestUrl(tab, screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
export const checkIsExitsReqArriveLateApi = async (payload, screenCode) => {
  const res = await baseHttpService.post(
    checkIsExitsReqArriveLateUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const createReqLeaveApi = async (payload, screenCode) => {
  const res = await baseHttpService.post(
    createReqLeaveUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const postFileApi = async (file: File): Promise<postFileRes> => {
  const formData = new FormData();

  formData.append("file", file);

  const res = await baseHttpService.post<postFileRes>(postFileUrl, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getLeaveManagerReqApi = async (data) => {
  const res = await baseHttpService.post(getLeaveManagerReqUrl, data);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const checkIsExitsReqLeaveApi = async (data, screenCode) => {
  const res = await baseHttpService.post(
    checkIsExitsReqLeaveUrl(screenCode),
    data
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListManagerOfDepartmentApi = async () => {
  const res = await baseHttpService.get(getListManagerOfDepartmentUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const sendFeedbackApi = async (payload, screenCode: SCREEN) => {
  const res = payload.id
    ? await baseHttpService.put(sendFeedbackUrl(screenCode), payload)
    : await baseHttpService.post(sendFeedbackUrl(screenCode), payload);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getConfigMinDateAPI = async () => {
  const res = await baseHttpService.get(getConfigMinDateUrl);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListTimeKeepingHRApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    getListTimeKeepingHRUrl(screenCode),
    rest.params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getCategoryOptionApi = async (params) => {
  const { categoryType, ...rest } = params;
  const res = await baseHttpService.get(getCategoryOptionUrl(categoryType), {
    "department-code": rest?.departmentCode,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const exportTimeKeepingHRApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    exportTimeKeepingHRUrl(screenCode),
    rest,
    {
      responseType: "blob", // Ensure response is treated as a file
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const confirmTimeKeepingApi = async ({
  screenCode,
  month,
  year,
}: {
  screenCode: SCREEN;
  month: string;
  year: string;
}) => {
  const res = await baseHttpService.post(
    confirmTimeKeepingMonthUrl(screenCode, month, year)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
export const getListTimeKeepingManagerApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    getListTimeKeepingManagerUrl(screenCode),
    rest
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const exportTimeKeepingMonthApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    exportTimeKeepingMonthUrl(screenCode),
    rest,
    {
      responseType: "blob", // Ensure response is treated as a file
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const confirmTimeKeepingAPI = async (formData) => {
  const { screenCode, ...rest } = formData;

  const res = await baseHttpService.post(
    confirmTimeKeepingUrl(screenCode),
    rest
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const exportTimeKeepingManagerApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    exportTimeKeepingManagerUrl(screenCode),
    rest,
    {
      responseType: "blob", // Ensure response is treated as a file
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getTimeKeepingManagerDetailAPI = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    getTimeKeepingManagerDetailUrl(screenCode),
    rest
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getRangeTimeKeepingAPI = async (params) => {
  const res = await baseHttpService.get(getRangeTimeKeepingUrl, params);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getEmployeeOfManagerAPI = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    getEmployeeOfManagerUrl(screenCode),
    rest
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getHrReportApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(getHrReportUrl(screenCode), rest);
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const exportHrReportApi = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(exportHrReportUrl(screenCode), rest, {
    responseType: "blob", // Ensure response is treated as a file
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getTimeConfirmPeriodAPI = async (params) => {
  const { screenCode, ...rest } = params;
  const res = await baseHttpService.get(
    getTimeConfirmPeriodUrl(screenCode),
    rest
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getTimeCheckInOnlineAPI = async (screenCode) => {
  const res = await baseHttpService.get(checkInOnlineApiUrl(screenCode));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const checkInOnlineApi = async (screenCode) => {
  const res = await baseHttpService.post(checkInOnlineApiUrl(screenCode));
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const cancelRequestApi = async (screenCode, id, reasonCancel, tab) => {
  const res = await baseHttpService.put(cancelRequestUrl(screenCode, tab), {
    cancelReason: reasonCancel,
    id,
  });
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const exportTemplateTimeKeepingApi = async (screen, params) => {
  const res = await baseHttpService.get(
    exportTemplateTimeKeepingUrl(screen),
    params,
    {
      responseType: "blob",
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const importTimeKeepingApi = async (screen, formData, params) => {
  const res = await baseHttpService.post(
    importTimeKeepingUrl(screen, params),
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getManagerApproveEarlyRegisterApi = async (screen, params) => {
  const res = await baseHttpService.get(
    getManagerApproveEarlyRegisterUrl(screen),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const createEarlyRegistrationApi = async (screen, formData) => {
  const res = await baseHttpService.post(
    createEarlyRegistrationUrl(screen),
    formData
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getEarlyRegistrationDetailApi = async (screen, id) => {
  const res = await baseHttpService.get(
    getEarlyRegistrationDetailUrl(screen, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const deleteEarlyRegistrationApi = async (screen, id) => {
  const res = await baseHttpService.delete(
    getEarlyRegistrationDetailUrl(screen, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
